import React from 'react';

const TulKanatSettings = React.memo(({
  extraPrices,
  setExtraPrices,
  activeTypeTab
}) => {
  const isTul = activeTypeTab === 'tul';
  const title = isTul ? 'Tül Pile Ek Ücret Ayarları (₺)' : 'Kanat Pile Ek Ücret Ayarları (₺)';

  return (
    <div className="settings-card">
      <div className="settings-card-title">
        <i className="fas fa-cut"></i>
        <h4>{title}</h4>
      </div>
      <div className="settings-grid">
        <div className="form-group">
          <label>S Pile</label>
          <input type="number" value={extraPrices.sPile} onChange={(e) => setExtraPrices(p => ({ ...p, sPile: e.target.value }))} />
        </div>
        <div className="form-group">
          <label>Amerikan 2'li</label>
          <input type="number" value={extraPrices.american2} onChange={(e) => setExtraPrices(p => ({ ...p, american2: e.target.value }))} />
        </div>
        <div className="form-group">
          <label>Amerikan 3'lü</label>
          <input type="number" value={extraPrices.american3} onChange={(e) => setExtraPrices(p => ({ ...p, american3: e.target.value }))} />
        </div>
        <div className="form-group">
          <label>Kapsül Pile</label>
          <input
            type="number"
            value={extraPrices.kapsul}
            onChange={(e) => setExtraPrices(p => ({ ...p, kapsul: e.target.value }))}
          />
        </div>
        {isTul && (
          <div className="form-group">
            <label>Alt Etek Katlama</label>
            <input
              type="number"
              value={extraPrices.altEtekKatlama}
              onChange={(e) => setExtraPrices(p => ({ ...p, altEtekKatlama: e.target.value }))}
            />
          </div>
        )}
      </div>
    </div>
  );
});

export default TulKanatSettings;
